import { AccountContext } from 'components/AccountContext';
import ChildHeader from 'components/Dashboard/Main/ChildHeader';
import React, { useContext } from 'react';
import {
  VStack,
  useDisclosure,
  chakra,
  HStack,
  Flex,
  Heading,
  Image,
  ButtonGroup,
  Button,
  Box,
  useToast,
  Divider,
  Drawer,
  DrawerContent,
  DrawerCloseButton,
} from '@chakra-ui/react';
import Baixar from '../../../images/Baixar.svg';
import ExcluirConta from '../../../images/ExcluirConta.svg';
import Cancelar from '../../../images/Cancelar.svg';
import BaixarContrato from '../../../images/BaixarContrato.svg';
import ContratoAdesao from '../../../termos/DM-467.pdf';
import { useLocation, useNavigate } from 'react-router-dom';
import ExcluirContaDrawer from './Modal/ExcluirContaDrawer';
import Pdf from 'components/PdfViewer';
import ModalB2b from './Modal/CancelamentoB2BAviso';
import { userIsSubscriber } from 'components/Utils/theme';

function MaisOpcoes() {
  const { setPage, user } = useContext(AccountContext);
  setPage('Outras opções');
  const navigate = useNavigate();
  const state = useLocation();
  const excluirContaDisclousure = useDisclosure();
  const modalB2bDisclousure = useDisclosure();
  const { dependentes, pet } = state.state;
  const toast = useToast();
  const assinante = userIsSubscriber(user);
  function callToast(title, descricao) {
    toast({
      title: 'Importante',
      description: 'Para cancelamento de contrato com forma de pagamento enel, entre em contato com nosso call center',
      status: 'warning',
      duration: 4000,
      isClosable: true,
      position: 'bottom',
      colorScheme: 'red',
      containerStyle: {
        paddingTop: '50px',
      },
    });
  }
  const disclousureTermosGerais = useDisclosure();
  return (
    <>
      <Drawer isCentered isFullHeight size="md" isOpen={disclousureTermosGerais.isOpen} onClose={disclousureTermosGerais.onClose} placement="bottom">
        <DrawerContent isCentered nbgColor="rgba(90, 178, 173, 0.7)" pt="10%">
          <Pdf file={ContratoAdesao} />
          <DrawerCloseButton color="red" borderColor="red" pt="15%" />
        </DrawerContent>
      </Drawer>
      <ChildHeader />
      <ExcluirContaDrawer disclosure={excluirContaDisclousure} />
      <ModalB2b disclosure={modalB2bDisclousure} />
      <Flex minW="210px" maxW="340px" mx="auto" overflow="hidden" p="1em" px={5} pt={5} pb="120px" height="calc(100vh - 80px)">
        <VStack align="flex-start" spacing={2.5} w="100%" h="100%">
          <VStack bg="#F3F3F3" borderRadius="0.8em" h="8em" w="100%" display={user.titular && assinante ? 'flex' : 'none'} justifyContent="center" alignItems="center">
            <Heading fontSize="16" color="#585858" display="flex" alignItems="center" p="1em">
              <Box mr="0.5em">
                <Image boxSize="13px" src={BaixarContrato} alt="" />
              </Box>
              Contrato Adesão
            </Heading>

            <chakra.p fontSize="16" w="80%" display="flex" justifyContent="center" alignItems="center">
              <ButtonGroup
                pt="1rem"
                w="100%"
                display="flex"
                justifyContent="center"
                alignItems="center"
                onClick={() =>
                  window?.ReactNativeWebView?.postMessage(
                    JSON.stringify({
                      service: true,
                      openInBrowser: true,
                      url: 'https://deovita.com.br/wp-content/uploads/2026/01/TERMO-DE-ADESAO-A-PLATAFORMA-DIGITAL-DEOVITA.pdf',
                    })
                  )
                }
              >
                <Button color="white" bg="#5AB2AE" w="100%" h="2em" display="flex" justifyContent="center" alignItems="center">
                  Baixar Contrato
                  <Image boxSize="13px" ml="1em" src={Baixar} alt="" />
                </Button>
              </ButtonGroup>
            </chakra.p>
          </VStack>
        </VStack>
      </Flex>
      <Box position="fixed" bottom={0} w="100%" zIndex={100} bg="white" boxShadow="0 -2px 8px rgba(0,0,0,0.08)" borderTopRadius="1em" maxW="340px" mx="auto" left="50%" style={{ transform: 'translateX(-50%)' }} p={4}>
        <VStack w="100%" align="flex-start">
          <Heading fontSize="16" fontWeight="bold" mb="1em">
            Opções
          </Heading>

          {user.titular && assinante && (
            <>
              <HStack
                spacing={4}
                w="100%"
                onClick={() => {
                  if (user.id_plano === 60) {
                    modalB2bDisclousure.onOpen();
                    return;
                  }

                  if (user.forma_pagamento !== 13) {
                    navigate('/perfil/assinaturas/cancelar-contrato', {
                      state: { dependentes, pets: pet },
                    });
                  } else {
                    callToast();
                  }
                }}
              >
                <Image boxSize="20px" src={Cancelar} alt="" />
                <chakra.span fontSize="12" color="#585858">
                  Cancelar contrato
                </chakra.span>
              </HStack>

              <Divider />
            </>
          )}

          {!user.titular && assinante && (
            <>
              <HStack spacing={4} w="100%" onClick={() => navigate('/perfil/assinaturas/titular-faleceu')}>
                <Image boxSize="20px" src={Cancelar} alt="" />
                <chakra.span fontSize="12" color="#585858">
                  Falecimento do titular
                </chakra.span>
              </HStack>

              <Divider />

              <HStack spacing={4} w="100%" onClick={() => navigate('/perfil/assinaturas/vira-titular')}>
                <Image boxSize="20px" src={Cancelar} alt="" />
                <chakra.span fontSize="12" color="#585858">
                  Quero me tornar titular
                </chakra.span>
              </HStack>

              <Divider />
            </>
          )}

          <HStack
            spacing={4}
            w="100%"
            onClick={() => {
              if (user.id_plano === 60) {
                modalB2bDisclousure.onOpen();
                return;
              }

              if (user.forma_pagamento !== 13) {
                if (user.titular) {
                  navigate('/perfil/assinaturas/cancelar-contrato', {
                    state: { dependentes, pets: pet, exclusao: true },
                  });
                } else {
                  navigate('/perfil/assinaturas/cancelar-contrato-dependente', {
                    state: { exclusao: true },
                  });
                }
              } else {
                callToast();
              }
            }}
          >
            <Image boxSize="20px" src={ExcluirConta} alt="" />
            <chakra.span fontSize="12" color="#585858">
              Excluir conta
            </chakra.span>
          </HStack>

          <Divider />
        </VStack>
      </Box>
    </>
  );
}

export default MaisOpcoes;
